import CSHARPBA from "./CSharp Basico Avancado CERT.png"
import CSHARPMVC from "./CSharp Com MVC CERT.png"
import CSHARPCRUD from "./CSharp CRUD CERT.png"
import BDCERT from "./Dominando Banco de Dados CERT.png"
import UNITYCERT from "./Unity CERT.png"
import WEBDESIGN from "./Web Design CERT.png"

const Certificates = {
  CSHARPBA,
  CSHARPMVC,
  CSHARPCRUD,
  BDCERT,
  UNITYCERT,
  WEBDESIGN
}

export default Certificates;